const Array_Sum = (t) => {
  return t.reduce(function(a, b) { return a + b; }, 0); 
}

export default Array_Sum;
